module.exports = __webpack_public_path__ + "static/media/picasso.0bfbb353.jpg";